import get from 'lodash/get';
import * as constants from '~/app/lib/redux/actions/action-types';

// makeId must return a unique ID
// we want it to be an integer for testing purposes
export const makeId = (componentDocument: any) => {
  const randomInt = Math.floor(Math.random() * Math.floor(1000000));
  return `${randomInt}-${componentDocument.type}`;
};

export const addComponent = (component: any, order: number) => ({
  type: constants.COMPONENT_ADDED,
  component,
  order,
});

export const updateComponent = (component: any) => ({
  type: constants.COMPONENT_UPDATED,
  component,
});

export const setComponentPath = (path: string) => ({
  type: constants.SET_COMPONENT_PATH,
  path,
});

export const setComponentType = (componentType: string) => ({
  type: constants.SET_COMPONENT_TYPE,
  componentType,
});

export const openEditor = {
  type: constants.EDITOR_OPEN,
};

export const selectComponent = (id: string) => ({
  type: constants.COMPONENT_SELECTED,
  id,
});

export const selectTab = (tab: number) => ({
  type: constants.EDITOR_TAB_SELECT,
  tab,
});

export const setDisableGridOutline = ({
  componentId,
  disableGridOutline,
}: {
  componentId: string;
  disableGridOutline: boolean;
}) => ({
  type: constants.SET_DISABLE_GRID_OUTLINE,
  payload: {
    componentId,
    disableGridOutline,
  },
});

export const setMarketplaceOfferIds = (
  componentId: string,
  marketplaceOffers: []
) => ({
  type: constants.SET_MARKETPLACE_OFFERS,
  componentId,
  marketplaceOffers,
});

export const buttonUrlWithCustomQueryParams = (
  url: string,
  searchParams: URLSearchParams
) => {
  try {
    const composedUrl = new URL(url);
    // eslint-disable-next-line no-restricted-syntax
    for (const param of searchParams) {
      composedUrl.searchParams.append(param[0], param[1]);
    }
    return composedUrl;
  } catch (error) {
    console.warn('Error composing URL with custom query params', error);
    return '';
  }
};

export const getInitialState = (
  currentComponent: any,
  componentPath: string,
  field: string,
  initialValue: any
) => {
  return get(currentComponent, `props.${componentPath}.${field}`, initialValue);
};

export function isValidUUID(id: string) {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(id);
}

export function changeOrder(
  array: string[],
  fromIndex: number,
  toIndex: number
) {
  const item = array.splice(fromIndex, 1)[0];
  array.splice(toIndex, 0, item);
  return array;
}
